import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./utils/i18n";

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap prerenders each route to static HTML at build time. When that
// pre-rendered markup is present we hydrate it (rather than throwing it away
// and re-rendering), so the static HTML the crawlers see stays in the DOM.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
